// IntakeAdmin — shared constants

export const PRACTICE_TIMEZONE = 'America/Chicago';
export const US_TIMEZONES = [
    { value: 'America/New_York', label: 'Eastern Time (ET)', abbr: 'ET' },
    { value: 'America/Chicago', label: 'Central Time (CT)', abbr: 'CT' },
    { value: 'America/Denver', label: 'Mountain Time (MT)', abbr: 'MT' },
    { value: 'America/Los_Angeles', label: 'Pacific Time (PT)', abbr: 'PT' },
    { value: 'America/Anchorage', label: 'Alaska Time (AKT)', abbr: 'AKT' },
    { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)', abbr: 'HT' },
];

export const CANCEL_REASONS = ['Patient Request', 'Provider Unavailable', 'Insurance Issue', 'No Response', 'Duplicate', 'Other'];
export const PASCAL_TO_SNAKE = {
    Requested: 'requested',
    Waitlisted: 'waitlisted',
    Scheduled: 'scheduled',
    Confirmed: 'confirmed',
    Completed: 'completed',
    Cancelled: 'cancelled',
    LateCancelled: 'late_cancelled',
    NoShow: 'no_show',
    Rescheduled: 'rescheduled',
    Booked: 'booked',
    CheckedIn: 'checked_in',
};
export const STATUS_BADGE = {
    booked: { label: 'Booked', classes: 'bg-blue-50 text-blue-700 ring-blue-600/20' },
    scheduled: { label: 'Scheduled', classes: 'bg-blue-50 text-blue-700 ring-blue-600/20' },
    requested: { label: 'Requested', classes: 'bg-slate-50 text-slate-800 ring-slate-600/20' },
    waitlisted: { label: 'Waitlisted', classes: 'bg-purple-50 text-purple-800 ring-purple-600/20' },
    confirmed: { label: 'Confirmed', classes: 'bg-green-50 text-green-700 ring-green-600/20' },
    checked_in: { label: 'Checked In', classes: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20' },
    completed: { label: 'Completed', classes: 'bg-emerald-50 text-emerald-800 ring-emerald-600/20' },
    cancelled: { label: 'Cancelled', classes: 'bg-red-50 text-red-700 ring-red-600/20' },
    late_cancelled: { label: 'Late cancelled', classes: 'bg-rose-50 text-rose-800 ring-rose-600/20' },
    no_show: { label: 'No Show', classes: 'bg-amber-50 text-amber-700 ring-amber-600/20' },
    rescheduled: { label: 'Rescheduled', classes: 'bg-violet-50 text-violet-800 ring-violet-600/20' },
};

export const ALL_APPOINTMENT_STATUSES = [
    'requested',
    'waitlisted',
    'scheduled',
    'confirmed',
    'completed',
    'cancelled',
    'late_cancelled',
    'no_show',
    'rescheduled',
];

export const APPOINTMENT_QUICK_CHANGE_STATUSES = [
    'scheduled',
    'confirmed',
    'completed',
    'cancelled',
    'no_show',
    'rescheduled',
];

export const DURATION_PRESETS = [15, 30, 45, 60,75, 90,105, 120];
export const INTAKE_FLOWS = [
    { value: 'standard', label: 'Standard intake' },
    { value: 'sleep-study', label: 'Sleep study intake' },
    { value: 'telehealth', label: 'Telehealth intake' },
    { value: 'none', label: 'None' },
];
export const FINANCIAL_COLLECTION_MODES = [
    { value: 'TruIntakePreVisit', label: 'TruIntake Pre-Visit' },
    { value: 'Manual', label: 'Manual Front Desk' },
    { value: 'HealthiePostVisit', label: 'Healthie Post-Visit Auto-Billing' },
];

export const TEMPLATE_STATE_DESCRIPTIONS = {
    A_not_started: "Sent when intake forms haven't been started",
    A_in_progress: 'Sent when intake is started but not finished',
    B_no_card: 'Sent when no payment method is on file',
    C_card_on_file: 'Sent when a balance is due',
    D_paid: 'Sent when intake and payment are complete',
};
export const TEMPLATE_VARIABLES = ['{firstName}', '{lastName}', '{practiceName}', '{appointmentDate}', '{appointmentTime}', '{providerName}', '{balanceDue}', '{intakeLink}', '{paymentLink}'];
export const TEMPLATE_VARIABLE_SAMPLES = {
    '{firstName}': 'Sarah',
    '{lastName}': 'Chen',
    '{practiceName}': 'Sleep Doctor, PLLC',
    '{appointmentDate}': 'Mar 15, 2026',
    '{appointmentTime}': '9:00 AM',
    '{providerName}': 'Dr. Amara Osei',
    '{balanceDue}': '$75.00',
    '{intakeLink}': 'https://intake.truintake.com/abc123',
    '{paymentLink}': 'https://pay.truintake.com/abc123',
};

export function formatProviderDisplay(provider) {
    return provider.credentials ? `${provider.name}, ${provider.credentials}` : provider.name;
}

export const DEFAULT_WORKLIST_FILTERS = {
    providerIds: [],
    locationNames: [],
    payerIds: [],
    eligibilityStatuses: [],
    paymentStatuses: [],
    appointmentTypes: [],
    hasOpenExceptionsOnly: false,
    readiness: null,
    intakeStatuses: [],
    formsStatuses: [],
    exceptionTypes: [],
    exceptionSeverities: [],
    coverageStatuses: [],
    networkStatuses: [],
    authStatuses: [],
    referralStatuses: [],
    contactTypes: [],
};
